export default __webpack_public_path__ + "static/area-guid_img-af80e76c5a485a0e4292ba4590caf715.jpg";